import React from "react";
import { connect } from "react-redux";
import { setEditData, setModalTemplate, setModalType, setShowEditSupplierModal } from '../../redux/modal/modal.actions';
import { createStructuredSelector } from 'reselect';
import { selectEditUUID, selectModalFormTemplate, selectShowEditSupplierModal } from "../../redux/modal/modal.reselect";
import { useEffect } from "react";

import EDIT_SUPPLIER_FORM_TEMPLATE from './edit-supplier.template.js';

import ModalContainer from "../modal/modal.container";
import useFetchEdit from "../../effects/use-fetch-edit.effect";
import { authTokenSelector } from "../../redux/user/user.reselect";

const EditSupplier = ({
    showEditSupplier,
    setModalTemplate,
    setModalType,
    formTemplate,
    editUUID,
    authToken,
    setShowEditSupplierModal,
    isFetching,
    setEditData
}) => {
    useEffect(() => {
        setModalType("EDIT_SUPPLIER")
        setModalTemplate(EDIT_SUPPLIER_FORM_TEMPLATE);
    }, []);
    const endpoint = '/suppliers';
    const endpointUrl = `${endpoint}/${editUUID}`;
    const authTokenFromState = authToken;

    const { data, error } = useFetchEdit(endpointUrl, authTokenFromState, showEditSupplier);

    useEffect(() => {
        setEditData(data)
    })
    
    return (
        <div className="edit-supplier">
            {
                Object.keys(formTemplate).length > 0 ?
                    <ModalContainer
                        showModal={showEditSupplier}
                        setShowModal={setShowEditSupplierModal}
                        endpointUrl={endpointUrl}
                        size={"LARGE"}
                    />
                    : null
            }
        </div>
    )
}

const mapStateToProps = createStructuredSelector({
    showEditSupplier: selectShowEditSupplierModal,
    formTemplate: selectModalFormTemplate,
    editUUID: selectEditUUID,
    authToken: authTokenSelector,
})

const mapDispatchToProps = (disptach) => ({
    setShowEditSupplierModal: () =>
        disptach(setShowEditSupplierModal()),
    setModalTemplate: (formTemplate) =>
        disptach(setModalTemplate(formTemplate)),
    setModalType: (modalType) =>
        disptach(setModalType(modalType)),
    setEditData: (editData) =>
        disptach(setEditData(editData))
})


export default connect(mapStateToProps, mapDispatchToProps)(EditSupplier);